export default __webpack_public_path__ + "static/media/ok.5d225c00.svg";